var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C8.62867 4 8.94267 4 9.138 4.19533C9.33333 4.39067 9.33333 4.70467 9.33333 5.33333V10.6667C9.33333 11.2953 9.33333 11.6093 9.138 11.8047C8.94267 12 8.62867 12 8 12M8 4C7.37133 4 7.05733 4 6.862 4.19533C6.66667 4.39067 6.66667 4.70467 6.66667 5.33333V10.6667C6.66667 11.2953 6.66667 11.6093 6.862 11.8047C7.05733 12 7.37133 12 8 12M8 4V2M8 12V14M12.6667 3.33333C13.2953 3.33333 13.6093 3.33333 13.8047 3.52867C14 3.724 14 4.038 14 4.66667V6C14 6.62867 14 6.94267 13.8047 7.138C13.6093 7.33333 13.2953 7.33333 12.6667 7.33333M12.6667 3.33333C12.038 3.33333 11.724 3.33333 11.5287 3.52867C11.3333 3.724 11.3333 4.038 11.3333 4.66667V6C11.3333 6.62867 11.3333 6.94267 11.5287 7.138C11.724 7.33333 12.038 7.33333 12.6667 7.33333M12.6667 3.33333V2M12.6667 7.33333V8.66667M3.33333 6.66667C3.962 6.66667 4.276 6.66667 4.47133 6.862C4.66667 7.05733 4.66667 7.37133 4.66667 8V9.33333C4.66667 9.962 4.66667 10.276 4.47133 10.4713C4.276 10.6667 3.962 10.6667 3.33333 10.6667M3.33333 6.66667C2.70467 6.66667 2.39067 6.66667 2.19533 6.862C2 7.05733 2 7.37133 2 8V9.33333C2 9.962 2 10.276 2.19533 10.4713C2.39067 10.6667 2.70467 10.6667 3.33333 10.6667M3.33333 6.66667V5.33333M3.33333 10.6667V12",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldings);
export default __webpack_public_path__ + "static/media/holdings.b4784c16dd8e51efaa8a76d1bc711c7c.svg";
export { ForwardRef as ReactComponent };